var map = {
	"./commercial_planning.svg": 24935,
	"./price_pack_architecture.svg": 81252,
	"./strategic_pricing.svg": 93016,
	"./trade_architecture.svg": 68567,
	"./trade_promotion.svg": 13105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50273;